var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatarLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m24.25 7-9.369.03-7.8 13.509 4.667 8.115z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m24.25 7-9.369.03-7.8 13.509 4.667 8.115z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "m36 7-9.37.03-7.8 13.509 4.667 8.115z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "m36 7-9.37.03-7.8 13.509 4.667 8.115z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#960145",
  d: "M12.502 7H0l5.914 10.842z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M12.502 7H0l5.914 10.842z"
})));
export default SvgAvatarLogo;